import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  assetVersionListPageTableCell: {
    color: theme.palette.text.primary,
    padding: "0% !important",
    width: "16.25%",
    borderBottom: `1px solid ${theme.palette.text.tertiary}`,
  },
  assetVersionListPageTableCellTwo: {
    color: theme.palette.text.primary,
    padding: "0% !important",
    overflow: "hidden",
    borderCollapse: "collapse",
    width: "10%",
    borderBottom: `1px solid ${theme.palette.text.tertiary}`,
  },
  assetVersionListPageTableCellThree: {
    color: theme.palette.text.primary,
    padding: "0% !important",
    overflow: "hidden",
    borderCollapse: "collapse",
    width: "15%",
    borderBottom: `1px solid ${theme.palette.text.tertiary}`,
  },
  assetsVersionModals: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  inlineButtons: {
    minWidth: "36px",
    borderRadius: "6px",
    padding: "6px",
    margin: "2px",
  },
}));

export default useStyles;
